import { type TCurrentLocation } from '@/packages/Filters/shared/types/location';
import { type TJsonQuery, getOfferTypeFromJsonQuery, isSuburban } from '@/packages/JsonQuery';

interface IParameters {
  location: TCurrentLocation;
  jsonQuery: TJsonQuery;
}

export function hasHighways({ location, jsonQuery }: IParameters): boolean {
  if (location === 'spb_lo') {
    return false;
  }

  return (location === 'moscow_mo' || location.hasHighway) && isSuburban(getOfferTypeFromJsonQuery(jsonQuery));
}
